import ExportModal, { ExportModalProps } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { useMemo } from 'react'
import { REBATE_CLAIMS_COLUMNS } from 'features/tradespend/rebateClaimsColumnInfo'

export default function ClaimExportModal(props: ExportModalProps) {
  const claimColumnHelper = createExportColumnHelper({
    columns: REBATE_CLAIMS_COLUMNS,
  })

  const columns = useMemo(() => {
    const cols = [
      {
        title: 'Claim Details',
        elements: [
          claimColumnHelper.retrieveColumn('company_name'),
          claimColumnHelper.retrieveColumn('status'),
          claimColumnHelper.retrieveColumn('payout_amount'),
          claimColumnHelper.retrieveColumn('enrollment_date'),
          claimColumnHelper.retrieveColumn('created'),
        ],
      },
      {
        title: 'Offer Details',
        elements: [
          claimColumnHelper.retrieveColumn('offer_name'),
          claimColumnHelper.retrieveColumn('products'),
        ],
      },
    ]
    return cols
  }, [])

  return (
    <ExportModal
      title="Select Columns for Claims Download"
      subTitle="Download up to 10,000 claims at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Claims"
      columns={columns}
      {...props}
    />
  )
}
